<div class="photos-container">
    <div class="alert alert-info" role="alert">
        <h6>
          <strong>Clooper recommends that you add high quality images and video links.</strong><br />
          <span>This helps the tenants to see your property in the best light possible, increasing your chances of renting out quickly and successfully.</span>
        </h6>
      </div>
      <form>
        <div class="form-section visible" [class.d-none]="images.length"  >
          <app-upload-box (fileUploadUpdate)="fileUploadUpdate($event)" accept="image/*" ></app-upload-box>
          <h6 class="caption-msg text-muted mt-2"> <fa-icon [icon]="icons.info" ></fa-icon> Upload at least one photo of the room</h6>
        </div>
        <div *ngIf='images.length'>
          <h5><b>Your photos</b></h5>
          <div *ngFor="let image of images" class="photo-item">
              <div class="d-flex align-items-center w-60">
                <div class="me-4"><img class="property-img" [src]="image.url || defaultImg" alt="img"></div>
                <div>
                  <h6 class="text-elips"><b>{{image.description}}</b></h6>
                </div>
              </div>
              <div>
                  <div *ngIf="!image._id" >
                    <div class="text-pry"><fa-icon [size]="'2x'" [icon]="icons.spinner" [spin]="true" ></fa-icon></div>
                  </div>
                  <ng-container *ngIf="image._id">
                    <div class="d-flex img-actions">
                      <h6 (click)="useAsThumbnail(image)" class="me-3 text-pry fs-12 cur-pnt hover-show" *ngIf="!image.is_default">
                        <b class="me-2">Use as thumbnail</b>
                        <span><fa-icon  [icon]="icons.check" ></fa-icon></span>
                      </h6>
                      <div class="me-3" *ngIf="image.is_default">
                        <span class="badge rounded-pill bg-lt-pry py-2 px-3">Thumbnail</span>
                      </div>
                      <h5 (click)="onAddCaption(imgCaptionModal,image)" class="fs-13 cur-pnt hover-show me-3"><fa-icon  [icon]="icons.pencil" ></fa-icon></h5>
                      <h5 (click)="onDeleteImg(deleteImgModal,image)" class="text-danger fs-13 cur-pnt hover-show"><fa-icon  [icon]="icons.times" ></fa-icon></h5>
                    </div>
                  </ng-container>
              </div>
          </div>
          <div class="my-3" >
            <app-upload-box (fileUploadUpdate)="fileUploadUpdate($event)" accept="image/*" viewType="upload-more" ></app-upload-box>
          </div>
        </div>
    </form>
    
</div>


<ng-template  #deleteImgModal>
    <app-confirm-modal 
    [bsModalRef]="modalRef"
    [confirm]="deleteImgModalData.confirm" 
    [confirmQuestion]="deleteImgModalData.confirmQuestion"
    [itemName]="deleteImgModalData.itemName"
    (getEvent)="deleteImage($event)"
    >
  </app-confirm-modal>
  </ng-template>   
  <ng-template #imgCaptionModal>
    <app-img-caption-modal
      [bsModalRef]="modalRef"
      [loading]="imgLoading.caption"
      [image]='selectedImg'
      (getEvent)="saveImgCaption($event)"
    >
    </app-img-caption-modal>
  </ng-template>